<template>
  <div id="app" class="flex flex-col min-h-screen">
    <!-- Navigation Bar -->
    <header class="bg-white shadow">
      <div class="container mx-auto px-4 py-4 flex items-center justify-between">
        <!-- Menu Icon for Mobile -->
        <button
            @click="toggleMobileMenu"
            class="md:hidden text-gray-700 focus:outline-none"
        >
          <svg
              class="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
          >
            <path
                v-if="!mobileMenuOpen"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
            />
            <path
                v-else
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <!-- Logo / Title -->
        <router-link to="/" class="text-xl font-bold text-gray-800">
          Charge Health Admin Portal
        </router-link>

        <!-- Desktop Navigation -->
        <nav class="hidden md:flex space-x-4">
          <router-link
              v-for="item in navigationItems"
              :key="item.title"
              :to="item.route"
              class="text-gray-600 hover:text-blue-600"
              active-class="text-blue-600 font-semibold"
          >
            {{ item.title }}
          </router-link>
        </nav>

        <!-- User Actions -->
        <div class="hidden md:flex items-center space-x-4">
          <button @click="logout" class="text-gray-600 hover:text-blue-600">
            Logout
          </button>
        </div>
      </div>

      <!-- Mobile Navigation -->
      <div
          v-if="mobileMenuOpen"
          class="md:hidden bg-white border-t border-b"
      >
        <nav class="container mx-auto px-4 py-4">
          <router-link
              v-for="item in navigationItems"
              :key="item.title"
              :to="item.route"
              class="block py-2 text-gray-600 hover:text-blue-600"
              @click="toggleMobileMenu"
              active-class="text-blue-600 font-semibold"
          >
            {{ item.title }}
          </router-link>
          <button @click="logout" class="block py-2 text-gray-600 hover:text-blue-600">
            Logout
          </button>
        </nav>
      </div>
    </header>

    <!-- Main Content -->
    <main class="flex-grow">
      <router-view></router-view>
    </main>

    <!-- Footer -->
    <footer class="bg-gray-800 text-gray-200 py-4">
      <div class="container mx-auto text-center">
        &copy; {{ new Date().getFullYear() }} Charge Health, Inc.
      </div>
    </footer>
  </div>
</template>

<script>

import authService from '@/services/auth';

export default {
  name: 'App',
  data() {
    return {
      mobileMenuOpen: false,
      navigationItems: [
        { title: 'Home', route: '/' },
        { title: 'Manage Nurses', route: '/users' },
        { title: 'Manage Hospitals', route: '/sites' },
        { title: 'Schedule Reports', route: '/reports' },
      ],
    };
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    logout() {
      authService.signOut();
    },
  },
};
</script>

<style scoped>
/* Optional custom styles */
</style>
